import React, {useMemo, useState} from 'react';
import {Switch, Tabs} from 'antd';
import GenericModal from '@src/components/shared/generic-modal/generic-modal';
import './user-settings-modal.scss';
import PublicIpsTab from '@src/components/features/user-settings/puplic-ips-tab/public-ips-tab';
import ApiKeyTab from '@src/components/features/user-settings/api-key-tab/api-key-tab';
import {useStores} from '@src/components/store';
import PolicyRecommendationsTab
    from '@src/components/features/user-settings/policy-recommendations-tab/policy-recommendations-tab';
import ReportSubscriptionTab
    from '@src/components/features/user-settings/report-subscription-tab/report-subscription-tab';
import {observer} from 'mobx-react-lite';

interface UserSettingsModalProps {
    onCloseHandler: () => void;
    initialPersonalTab?: boolean; // default false - Company tab is shown by default when opening the modal
}

const createTab = (key: string, label: string, tab: React.ReactNode)=> {
    return {
        key: key,
        label: label,
        children: tab,
    };
};

const UserSettingsModal: React.FC<UserSettingsModalProps> = observer(({ onCloseHandler, initialPersonalTab = false } : UserSettingsModalProps) => {
    const {userStore, customerStore} = useStores();

    const [toggleChecked, setToggleChecked] = useState(userStore.isPersonalViewVisible ? initialPersonalTab : false);

    const companyTabs = useMemo(() => {
        const items = [
            createTab('1', 'Public IPs', <PublicIpsTab/>),
            ...(userStore.isApiKeyTabVisible ? [createTab('2', 'API Key', <ApiKeyTab/>)] : []),
            ...(userStore.isPolicyRecommendationTabVisible ? [createTab('3', 'Policy recommendations', <PolicyRecommendationsTab/>)] : [])
        ];
        return <Tabs defaultActiveKey="1" items={items} />;
    },[userStore.isApiKeyTabVisible, userStore.isPolicyRecommendationTabVisible]);

    const modalBodyElement = useMemo(() => (
        <>
            { userStore.isPersonalViewVisible &&
                <div className={toggleChecked ? '' : 'tab-hidden'}>
                    <ReportSubscriptionTab />
                </div>
            }
            <div className={!customerStore.hasNonBronzeConnection || !toggleChecked ? '' : 'tab-hidden'}>
                {companyTabs}
            </div>
        </>
    ), [toggleChecked, companyTabs, userStore.isPersonalViewVisible]);

    const modalTitleElement= useMemo(()=> (
            <div className="modal-header">
                <div className = "ant-modal-confirm-title">Settings</div>
                { userStore.isPersonalViewVisible &&
                    <Switch
                        checked={toggleChecked}
                        onChange={(value) => setToggleChecked(value)}
                        checkedChildren={<span className="switch-label company">Company</span>}
                        unCheckedChildren={<span className="switch-label personal">Personal</span>}
                    />
                }
            </div>
    ), [toggleChecked, userStore.isPersonalViewVisible]);

    return (
        <GenericModal
            open={true}
            title={modalTitleElement}
            wrapClassName="user-settings-modal"
            closable={true}
            width={800}
            body={modalBodyElement}
            actionButtons={[]}
            onCancel={onCloseHandler}
        />
    );
});

export default UserSettingsModal;